module.exports = __webpack_public_path__ + "static/media/Eterno Modular Sofa Console.8cedc16a.jpg";